module.exports = __webpack_public_path__ + "static/media/ltp.2e80cc8a.png";